var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentIndex === _vm.myIndex),expression:"currentIndex === myIndex"}],staticClass:"carousel-product-slide-component"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }